import { IOffer } from '../../../types/offer';

const COWORKING_CATEGORY_NAME = {
  office: 'Гибкий офис',
  fixedWorkplace: 'Закрепленное рабочее место',
  flexibleWorkplace: 'Незакрепленное рабочее место',
  conferenceHall: 'Конференц-зал',
  meetingRoom: 'Переговорная комната',
};

const DEFAULT_NAME = 'Офис';

export function getOfficeTitle({ coworkingOfferType }: IOffer) {
  if (!coworkingOfferType) {
    return DEFAULT_NAME;
  }

  return COWORKING_CATEGORY_NAME[coworkingOfferType] || DEFAULT_NAME;
}
